import React, { useState } from "react";

const SearchForm = ({ onSearch, listCauHinhTaiSan }) => {
    const [dataSearch, setDataSearch] = useState({
        CauHinhTaiSanId: "",
    });

    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSearchClick = () => {
        onSearch(dataSearch.CauHinhTaiSanId);
    };

    return (<>
        <div className="search-new">
            <div className="input-sm-new input-new-18">
                <label htmlFor="CauHinhTaiSanId" className="font-color-default font-bold">Loại tài sản</label>
                <select id="CauHinhTaiSanId" name="CauHinhTaiSanId"
                    value={dataSearch.CauHinhTaiSanId}
                    onChange={onChangeData("CauHinhTaiSanId")}
                    className="form-control input-sm">
                    {listCauHinhTaiSan && listCauHinhTaiSan.map((cauhinh, index) => (
                        <option key={index} value={cauhinh.CauHinhTaiSanId}>
                            {cauhinh.TenHangHoa}
                        </option>
                    ))}
                </select>
            </div>
            <div className="input-sm-new input-new-18 search-main-new">
                <label htmlFor="submit" className="font-color-default font-bold" >&nbsp;</label>
                <button
                    id="submit"
                    name="submit"
                    type="submit"
                    className="btn btn-info-new"
                    onClick={handleSearchClick}
                >
                    <i className="la la-search"></i>
                    <span> &nbsp; Tìm kiếm</span>
                </button>
            </div>
        </div>
    </>
    )
};


export default SearchForm;